import { getToken, getTokenExpiry, Logout, logout } from "./auth";

let logoutTimer;

export function setupAutoLogout() {
  const token = getToken();
  if (!token) return;

  const expiryTime = getTokenExpiry(token);
  if (!expiryTime) {
    Logout();
    return;
  }

  const remainingTime = expiryTime - Date.now();

  if (remainingTime <= 0) {
    Logout();
    return;
  }

  clearTimeout(logoutTimer);

  logoutTimer = setTimeout(() => {
    Logout();
  }, remainingTime);
}
